module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "trust.610f9b95.svg";